import { render, staticRenderFns } from "./ComentariosPedidoModal.vue?vue&type=template&id=bc4c3544&scoped=true&"
import script from "./ComentariosPedidoModal.vue?vue&type=script&lang=js&"
export * from "./ComentariosPedidoModal.vue?vue&type=script&lang=js&"
import style0 from "./ComentariosPedidoModal.vue?vue&type=style&index=0&id=bc4c3544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4c3544",
  null
  
)

export default component.exports